export const STORE_TOP_PAGE = 'topPage';
export const TP_FETCH_DATA = 'fetchData';
export const TP_SELECT_HOTEL = 'selectHotel';
export const TP_CREATE_WIDGET = 'createWidget';
export const TP_EDIT_WIDGET = 'editWidget';
export const TP_DELETE_WIDGET = 'deleteWidget';
export const TP_SORT_WIDGET = 'sortWidget';
export const TP_TOGGLE_HIDING = 'hideWidget';
export const TP_GET_COMPETITORS_DATA = 'getCompetitorsData';
export const TP_GET_REVIEWS_DATA = 'getReviewsData';
export const TP_GET_EVENTS_DATA = 'getEventsData';

export const TP_MAX_SHORTCUTS_COUNT = 50;
export const TP_MAX_SHORTCUT_NAME_LENGTH = 25;
export const TP_LAST_VISIBLE_INDEX = 3;

export const TP_ICON_CLASSES = {
  competitors: 'fas fa-users',
  edit_competitors: 'far fa-edit',
  custom: 'fas fa-link',
  events: 'far fa-calendar-alt',
  favorite_hotels: 'far fa-star',
  home: 'fas fa-building',
  search: 'fas fa-search',
  information: 'fas fa-info-circle',
  news: 'far fa-newspaper',
  reviews: 'far fa-comment-dots',
  review_analytics: 'far fa-comment',
  updates: 'fas fa-redo-alt',
};
